import imgInspectorDotGrey from '@/assets/steering备份 7@2x.png'
import imgInspectorDotBlue from '@/assets/steering备份 8@2x.png'
import imgInspectorDotGreen from '@/assets/steering备份 9@2x.png'
import imgInspectorPinPale from '@/assets/pin备份 9@2x.png'
import imgInspectorPinBlue from '@/assets/pin备份 8@2x.png'

/** Unassign 后尚未重新排期：关闭弹层时需切回 Schedule 并写 Pending Schedule */
export const CARE_SCHEDULE_CLEARED_KEY = 'careScheduleClearedByUser'
/** 历史遗留键：曾持久化已确认的时段/检查员，现仅用于打开排程页时清理 */
export const CARE_SCHEDULE_ASSIGNMENTS_KEY = 'careScheduleAssignments'

export const WEEKDAY_LABELS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'] as const

export const INSPECTOR_DOT_ICONS = [imgInspectorDotGrey, imgInspectorDotBlue, imgInspectorDotGreen] as const
/** 与圆点色系对应：浅蓝(steering7)→pin9，亮蓝(steering8)→pin8；绿(steering9) 无绿色 pin 资源，订单列表用 pin8 形 + CSS 着色 */
export const INSPECTOR_PIN_ICONS = [imgInspectorPinPale, imgInspectorPinBlue, imgInspectorPinBlue] as const
/** 与 `steering备份 9@2x.png` 圆点主色一致（rgb 152,213,190） */
export const INSPECTOR_GREEN_COLOR = '#98d5be'

/** 5×5 排程网格（列对齐设计稿：自 17 号列至 21 号列；末行右下留空一格） */
export const TIME_SLOT_GRID: readonly (readonly (string | null)[])[] = [
  ['08:00AM', '08:30AM', '09:00AM', '09:30AM', '10:00AM'],
  ['10:30AM', '11:00AM', '11:30AM', '12:00PM', '12:30PM'],
  ['01:00PM', '01:30PM', '02:00PM', '02:30PM', '03:00PM'],
  ['03:30PM', '04:00PM', '04:30PM', '05:00PM', '05:30PM'],
  ['06:00PM', '06:30PM', '07:00PM', '07:30PM', null],
] as const

export const SLOT_INTERVAL_MINUTES = 30
